import * as Sentry from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry(): void {
  if (!SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_VERSION || 'unknown',

    // Capture 100% of errors, sample 10% of transactions
    tracesSampleRate: 0.1,

    // Filter out noisy browser errors
    beforeSend(event: Sentry.ErrorEvent) {
      // Ignore browser extension errors
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
        (frame: { filename?: string }) => frame.filename?.includes('extension://')
      )) {
        return null;
      }
      return event;
    },
  });
}

export { Sentry };
